import { render, staticRenderFns } from "./MetricasCadastros.vue?vue&type=template&id=4820025f&scoped=true"
import script from "./MetricasCadastros.vue?vue&type=script&lang=js"
export * from "./MetricasCadastros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820025f",
  null
  
)

export default component.exports